import { AppContext } from '@lightspeed-invoicing/core-client/frontend';
import {
    defineMessages,
} from 'react-intl';
import { getCustomFilters } from './customFilters.jsx';


const messages = defineMessages({
    "search_placeholder": {
        id: 'invoice.listing.search_placeholder',
        defaultMessage: 'Search an invoice...',
    },
    "customer_type_placeholder": {
        id: 'invoice.listing.customer_type_placeholder',
        defaultMessage: 'Customer type',
    },
    "status_filter_placeholder": {
        id: 'invoice.listing.status_filter_placeholder',
        defaultMessage: 'Filter by status',
    },
    "identifier": {
        id: "invoice.listing.headers.id_label",
        defaultMessage: 'ID'
    },
    "due_date": {
        id: 'invoice.listing.filters.date.due_date',
        defaultMessage: 'Due date',
    },
    "last_payment_at": {
        id: 'invoice.listing.filters.date.last_payment_at',
        defaultMessage: 'Last payment date',
    },
    "effective_date": {
        id: 'invoice.listing.filters.date.effective_date',
        defaultMessage: 'Effective date',
    },
    "fully_paid_at": {
        id: 'invoice.listing.filters.date.fully_paid_at',
        defaultMessage: 'Fully paid date',
    },
    "created_at": {
        id: 'invoice.listing.filters.date.created_at',
        defaultMessage: 'Created date',
    },
    "ordered_at": {
        id: "order.listing.headers.ordered_at_label",
        defaultMessage: 'Ordered at date',
    },
    "updated_at": {
        id: 'invoice.listing.filters.date.updated_at',
        defaultMessage: 'Updated date',
    },
    "contact_nameSort": {
        id: "invoice.listing.headers.contact_nameSort",
        defaultMessage: "Contact",
    },
    "status": {
        id: "invoice.listing.headers.status_label",
        defaultMessage: "Status",
    },
    "total_amount": {
        id: "invoice.listing.headers.total_amount",
        defaultMessage: "Amount",
    },
    "purchase_order": {
        id: "invoice.listing.headers.purchase_order",
        defaultMessage: "Purchase order",
    },
    "balance": {
        id: "invoice.listing.headers.balance_label",
        defaultMessage: "Balance",
    },
    "poNumber": {
        id: "invoice.listing.headers.po_number",
        defaultMessage: "Po Number",
    },
    "assignedToUserId": {
        id: "invoice.listing.headers.assigned_user",
        defaultMessage: "Assigned User",
    },
    "sellerId": {
        id: "invoice.listing.headers.seller_id",
        defaultMessage: "User id",
    },
    "location": {
        id: "invoice.listing.headers.location",
        defaultMessage: "Location",
    },
    "imported_at": {
        id: "invoice.listing.headers.imported_at",
        defaultMessage: "Imported at date",
    },
    "contact_firstname": {
        id: "invoice.listing.headers.contact_firstname",
        defaultMessage: "Contact first name",
    },
    "contact_lastname": {
        id: "invoice.listing.headers.contact_lastname",
        defaultMessage: "Contact last name",
    },
    "contact_organization_name": {
        id: "invoice.listing.headers.contact_organization_name",
        defaultMessage: "Contact organization name",
    },
    "contact_type": {
        id: "invoice.listing.headers.contact_type",
        defaultMessage: "Contact type",
    },
    "contact_phonenumber": {
        id: "invoice.listing.headers.contact_phonenumber",
        defaultMessage: "Contact phone number",
    },
    "contact_email": {
        id: "invoice.listing.headers.contact_email",
        defaultMessage: "Contact email",
    },
    "contact_name": {
        id: "invoice.listing.headers.contact_name",
        defaultMessage: "Contact name",
    },
    "contact_id": {
        id: "invoice.listing.headers.contact_id",
        defaultMessage: "Contact id",
    },
    "sent_at": {
        id: "invoice.listing.headers.sent_at",
        defaultMessage: "Sent at date",
    },
    "voided_at": {
        id: "invoice.listing.headers.voided_at",
        defaultMessage: "Voided at date",
    },
    "paid_amount": {
        id: "invoice.listing.headers.paid_amount",
        defaultMessage: "Paid amount",
    },
    "currency": {
        id: "invoice.listing.headers.currency",
        defaultMessage: "Currency",
    },
    "tax_id": {
        id: "invoice.listing.headers.tax_id",
        defaultMessage: "Tax",
    },
    "payment_transaction_payment_type": {
        id: "invoice.listing.headers.payment_transaction_payment_type",
        defaultMessage: "Type of payment",
    },
    "payment_transaction_payment_amount": {
        id: "invoice.listing.headers.payment_transaction_payment_amount",
        defaultMessage: "Payment Transaction amount",
    },
    "order_id": {
        id: "order.listing.headers.order_id",
        defaultMessage: "Order id",
    },
    "payment_term": {
        id: "invoice.listing.headers.payment_term",
        defaultMessage: "Payment term",
    },
    "tax_number": {
        id: 'invoice.listing.customer_tax_number_placeholder',
        defaultMessage: 'Contact tax number',
    },
    "project_id": {
        id: "invoice.listing.headers.project_id",
        defaultMessage: "Contact organization name",
    },
    "external_links_integration_key": {
        id: "invoice.listing.headers.external_links_integration_key",
        defaultMessage: "External links integration",
    },
    "external_links_external_id": {
        id: "invoice.listing.headers.external_links_external_id",
        defaultMessage: "External links id",
    },
    "product_id": {
        id: "invoice.listing.headers.product_id",
        defaultMessage: "Product",
    },
    "product_label": {
        id: "invoice.listing.headers.product_label",
        defaultMessage: "Product label",
    },
    "product_title": {
        id: "invoice.listing.headers.product_title",
        defaultMessage: "Product title",
    },
    "product_sku": {
        id: "invoice.listing.headers.product_sku",
        defaultMessage: "Product sku",
    },
    "most_used_filters": {
        id: "invoice.listing.headers.most_used_filters",
        defaultMessage: "Most used filters",
    },
    "date_related_filters": {
        id: "invoice.listing.headers.date_related_filters",
        defaultMessage: "Date related filters",
    },
    "contact_related_filters": {
        id: "invoice.listing.headers.contact_related_filters",
        defaultMessage: "Contact related filters",
    },
    "payment_related_filters": {
        id: "invoice.listing.headers.payment_related_filters",
        defaultMessage: "Payment related filters",
    },
    "product_related_filters": {
        id: "invoice.listing.headers.product_related_filters",
        defaultMessage: "Product related filters",
    },
    "other_filters": {
        id: "invoice.listing.headers.other_filters",
        defaultMessage: "Other filters",
    },
    "custom_status_date_filters": {
        id: "invoice.listing.headers.custom_status_date_filters",
        defaultMessage: "Custom status date filters",
    },
    "is_archived": {
        id: "invoice.listing.headers.show_archived",
        defaultMessage: "Show archived",
    },
    "row_custom_status": {
        id: "order.listing.headers.row_status",
        defaultMessage: "Row status",
    },
    "project_title": {
        id: "order.listing.headers.project_title",
        defaultMessage: "Project title",
    },
})


export const customDatePath = 'customDatesStatus';
export const customDateFilterMatchId = 'customDatesStatus.customStatusId';
export const customDateFilterMatchDate = 'customDatesStatus.changedAt';

export const orderTotals = [
    'baseCurrencyTotalAmount',
    'balance',
]

export const orderFields = [
    'identifier',
    'identifierAnalyzed',
    'identifierNumber',
    'identifierKeyword',
    'poNumber',
    'poNumberAnalyzed',
    'poNumberKeyword',
    'poExternalIdAnalyzed',
    'contact.name',
    'contact.nameAnalyzed',
    'contact.nameKeyword',
    'contact.organizationNameKeyword',
    'contact.organizationNameAnalyzed',
    'projectTitle',
    'projectTitleAnalyzed',
]


export const getOrdersFilters = function (context) {
    var statuses = AppContext.orderStatuses
    var i = 0

    var orderFilters = statuses.map(elem => {
        i = i + 1
        return {
            nameId: "custom" + i,
            label: elem.attributes.name,
            elementSubtype: 'custom-status',
            id: elem.id,
            filterMatchStatus: customDateFilterMatchId,
            filterMatch: customDateFilterMatchDate,
            type: 'date',
            initialValue: { startDate: null, endDate: null },
            initialSelect: 'is'
        }
    })

    var newFiltersAux = [{ section: context.intl.formatMessage(messages["custom_status_date_filters"]) }].concat(orderFilters).concat(getCustomFilters(context, "orders"))
    var filtersToUse =
        [
            {
                section: context.intl.formatMessage(messages["most_used_filters"]),
            },
            {
                nameId: 'isArchived',
                label: context.intl.formatMessage(messages["is_archived"]),
                filterMatch: 'isArchived',
                type: 'boolean',
                placeHolder: 'Show archived',
                initialValue: '',
                initialSelect: 'is',
            },
            {
                nameId: 'userId',
                label: context.intl.formatMessage(messages["sellerId"]),
                filterMatch: 'sellerId',
                type: 'select',
                typeOfSelect: 'user-select',
                placeHolder: 'Select User',
                initialValue: '',
                initialSelect: 'isOneOf'
            },
            {
                nameId: 'locationId',
                label: context.intl.formatMessage(messages["location"]),
                filterMatch: 'locationId',
                type: 'select',
                typeOfSelect: 'location-select',
                placeHolder: 'Select Location',
                initialValue: [],
                initialSelect: 'isOneOf'
            },
            {
                nameId: 'statuses',
                label: context.intl.formatMessage(messages["status"]),
                type: 'select',
                filterMatch: 'customStatusId',
                typeOfSelect: 'order-status-select',
                placeHolder: context.intl.formatMessage(messages["status_filter_placeholder"]),
                initialValue: [],
                initialSelect: 'isOneOf'
            },
            {
                nameId: "poNumber",
                label: context.intl.formatMessage(messages["poNumber"]),
                filterMatch: 'poNumberKeyword',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: 'customerLabelIds',
                label: context.intl.formatMessage(messages["customer_type_placeholder"]),
                filterMatch: 'contact.labelIds',
                type: 'select',
                typeOfSelect: 'label-select',
                multi: false,
                placeHolder: context.intl.formatMessage(messages["customer_type_placeholder"]),
                labelName: "customerTypeId",
                labelType: "customer-type",
                initialValue: [],
                initialSelect: 'isOneOf'
            },
            {
                nameId: 'amount',
                label: context.intl.formatMessage(messages["total_amount"]),
                nameField: 'totalAmount',
                filterMatch: 'totalAmount',
                type: 'number',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: "purchaseOrder",
                label: context.intl.formatMessage(messages["purchase_order"]),
                filterMatch: 'poExternalIdAnalyzed',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },

            {
                section: context.intl.formatMessage(messages["date_related_filters"]),
            },
            {
                nameId: 'createdAt',
                label: context.intl.formatMessage(messages["created_at"]),
                filterMatch: 'createdAt',
                type: 'date',
                initialValue: { startDate: null, endDate: null },
                initialSelect: 'is'
            },
            {
                nameId: 'orderedAt',
                label: context.intl.formatMessage(messages["ordered_at"]),
                filterMatch: 'orderedAt',
                type: 'date',
                initialValue: { startDate: null, endDate: null },
                initialSelect: 'is'
            },
            {
                nameId: 'updatedAt',
                label: context.intl.formatMessage(messages["updated_at"]),
                filterMatch: 'updatedAt',
                type: 'date',
                initialValue: { startDate: null, endDate: null },
                initialSelect: 'is'
            },
            {
                section: context.intl.formatMessage(messages["contact_related_filters"]),
            },
            {
                nameId: 'contactId',
                label: context.intl.formatMessage(messages["contact_id"]),
                filterMatch: 'contactId',
                type: 'select',
                typeOfSelect: 'customer-select',
                initialValue: '',
                initialSelect: 'isOneOf'
            },
            {
                nameId: 'name',
                label: context.intl.formatMessage(messages["contact_name"]),
                filterMatch: 'contact.name',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: 'firstName',
                label: context.intl.formatMessage(messages["contact_firstname"]),
                filterMatch: 'contact.firstNameKeyword',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: 'lastName',
                label: context.intl.formatMessage(messages["contact_lastname"]),
                filterMatch: 'contact.lastNameKeyword',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: 'organizationName',
                label: context.intl.formatMessage(messages["contact_organization_name"]),
                filterMatch: 'contact.organizationNameKeyword',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: 'contactType',
                label: context.intl.formatMessage(messages["contact_type"]),
                filterMatch: 'contact.type',
                type: 'select',
                typeOfSelect: 'contactType-select',
                initialValue: [],
                initialSelect: 'isOneOf'
            },
            {
                nameId: 'phoneNumber',
                label: context.intl.formatMessage(messages["contact_phonenumber"]),
                filterMatch: 'contact.phoneNumberKeyword',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: 'taxNumber',
                label: context.intl.formatMessage(messages["tax_number"]),
                filterMatch: 'contact.taxNumber',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: 'email',
                label: context.intl.formatMessage(messages["contact_email"]),
                filterMatch: 'contact.emailKeyword',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                section: context.intl.formatMessage(messages["product_related_filters"]),
            },
            {
                nameId: "productId",
                label: context.intl.formatMessage(messages["product_id"]),
                filterMatch: 'rows.id',
                filterMatchNotOneOf: 'rowsObject.id',
                type: 'select',
                subtype: 'nested',
                typeOfSelect: 'product-select',
                initialValue: [],
                initialSelect: 'isOneOf'
            },
            {
                nameId: "productTitle",
                label: context.intl.formatMessage(messages["product_title"]),
                filterMatch: 'rows.title',
                filterMatchNot: 'rowsObject.title',
                type: 'text',
                subtype: 'nested',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: "productSku",
                label: context.intl.formatMessage(messages["product_sku"]),
                filterMatch: 'rows.sku',
                filterMatchNot: 'rowsObject.sku',
                type: 'text',
                subtype: 'nested',
                initialValue: '',
                initialSelect: 'is'
            },
            {

                nameId: "productLabel",
                label: context.intl.formatMessage(messages["product_label"]),
                filterMatch: 'rows.labelIds',
                filterMatchNotOneOf: 'rowsObject.labelIds',
                type: 'select',
                subtype: 'nested',
                typeOfSelect: 'product-label-select',
                initialValue: [],
                initialSelect: 'isOneOf'
            },
            {
                nameId: "assignedToUserId",
                label: context.intl.formatMessage(messages["assignedToUserId"]),
                filterMatch: 'rows.assignedToUserId',
                filterMatchNotOneOf: 'rowsObject.assignedToUserId',
                type: 'select',
                subtype: 'nested',
                typeOfSelect: 'user-select',
                initialValue: [],
                initialSelect: 'isOneOf'
            },
            {
                section: context.intl.formatMessage(messages["other_filters"]),
            },
            {
                nameId: 'taxID',
                label: context.intl.formatMessage(messages["tax_id"]),
                filterMatch: 'taxId',
                type: 'select',
                initialValue: [],
                typeOfSelect: 'tax-select',
                initialSelect: 'isOneOf'
            },
            {
                nameId: 'paymentType',
                label: context.intl.formatMessage(messages["payment_transaction_payment_type"]),
                filterMatch: 'paymentTransactions.paymentTypeId',
                filterMatchNotOneOf: 'paymentTransactionsObject.paymentTypeId',
                type: 'select',
                typeOfSelect: 'payment-type-select',
                subtype: 'nested',
                initialValue: '',
                initialSelect: 'isOneOf'
            },
            {
                nameId: 'paymentsAmount',
                label: context.intl.formatMessage(messages["payment_transaction_payment_amount"]),
                nameField: 'paymentTransactions.amount',
                filterMatch: 'paymentTransactions.amount',
                type: 'number',
                subtype: 'nested',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: "projectId",
                label: context.intl.formatMessage(messages["project_id"]),
                filterMatch: 'projectId',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: "identifier",
                label: context.intl.formatMessage(messages["order_id"]),
                filterMatch: 'identifier',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: "rowCustomStatusId",
                label: context.intl.formatMessage(messages["row_custom_status"]),
                filterMatch: 'rowsObject.rowCustomStatusId',
                filterMatchNotOneOf: 'rowsObject.rowCustomStatusId',
                type: 'select',
                typeOfSelect: 'row-custom-status',
                placeHolder: 'Select row status',
                initialSelect: 'isOneOf'
            },
            {
                nameId: 'projectTitle',
                label: context.intl.formatMessage(messages["project_title"]),
                filterMatch: 'projectTitleSort',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
        ]

    return filtersToUse.concat(newFiltersAux)

}





// WEBPACK FOOTER //
// ./src/common/search-filter/search/ordersFilters.jsx